import { apiRequest } from "@/lib/api/http";

interface RemoteLogo {
  filename?: string;
  mime?: string;
  size?: string;
  base64?: string;
}

interface LogoResponse {
  success?: boolean;
  data?: RemoteLogo | null;
}

/**
 * The account's own brand mark as a data URL, or `null` when it has none. An account without a
 * logo is the normal case rather than a failure, so every error is swallowed and the caller keeps
 * whatever default it already had.
 */
export async function fetchClientLogo(): Promise<string | null> {
  let response: LogoResponse;
  try {
    response = await apiRequest<LogoResponse>("/api/logo", {
      method: "GET",
      cache: "no-store",
    });
  } catch {
    return null;
  }

  const logo = response?.data;
  if (!logo?.base64 || !logo.mime?.startsWith("image/")) return null;
  return `data:${logo.mime};base64,${logo.base64}`;
}
